import request from '@/utils/request'


// 查询宠物品种列表
export function listBreed(query) {
  return request({
    url: '/mibo/pet-breed/list',
    method: 'get',
    params: query
  })
}

// 查询宠物品种分页
export function pageBreed(query) {
  return request({
    url: '/mibo/pet-breed/page',
    method: 'get',
    params: query
  })
}

// 查询宠物品种详细
export function getBreed(data) {
  return request({
    url: '/mibo/pet-breed/detail',
    method: 'get',
    params: data
  })
}

// 新增宠物品种
export function addBreed(data) {
  return request({
    url: '/mibo/pet-breed/add',
    method: 'post',
    data: data
  })
}

// 修改宠物品种
export function updateBreed(data) {
  return request({
    url: '/mibo/pet-breed/edit',
    method: 'post',
    data: data
  })
}

// 删除宠物品种
export function delBreed(data) {
  return request({
    url: '/mibo/pet-breed/delete',
    method: 'post',
    data: data
  })
}
